import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../../services/auth.service";
import { ClientService } from "../../../services/client.service";
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ConfigService } from "../../../utils/config.service";
import { HttpErrorResponse } from '@angular/common/http';
import { data } from 'jquery';
declare var $: any;

@Component({
  selector: 'sa-full-screen',
  templateUrl: './full-screen.component.html'
})
export class FullScreenComponent implements OnInit {
  model: any = {};
  clientDetails: any;
  userName: any;

  constructor(private router: Router, private authService: AuthService, private config: ConfigService, private clientService: ClientService) {
    this.clientDetails = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit() {
  }

  logOut() {
    this.authService.logout();
    this.userName = this.clientDetails.user.UserName;
    this.authService.updateLoginRecord(this.userName).toPromise().then((data: any) => {
      // var result = data;
    },(err : HttpErrorResponse)=>{});
    this.router.navigateByUrl('/auth/login');
  }
  onToggle() {
    var $body = $('body');
    var documentMethods = {
      enter: ['requestFullscreen', 'mozRequestFullScreen', 'webkitRequestFullscreen', 'msRequestFullscreen'],
      exit: ['cancelFullScreen', 'mozCancelFullScreen', 'webkitCancelFullScreen', 'msCancelFullScreen']
    };

    if (!$body.hasClass("full-screen")) {
      $body.addClass("full-screen");
      document.documentElement[documentMethods.enter.filter((method) => {
        return document.documentElement[method]
      })[0]]()
    } else {
      $body.removeClass("full-screen");
      document[documentMethods.exit.filter((method) => {
        return document[method]
      })[0]]()
    }
  }
}

